<template>
  <div class="animated fadeIn">
    
    <form @submit.stop.prevent="abrirMovimento()">
      <b-row class="my-0">
        <b-col sm="12">
          <b-card no-body class="mb-3 dashboard-card shadow-sm border-0 overflow-hidden">
            <div class="dashboard-header p-3 d-flex align-items-center justify-content-between text-white">
              <div class="d-flex align-items-center">
                <div class="header-icon-wrapper mr-3">
                  <i class="fa fa-university"></i>
                </div>
                <div>
                  <h5 class="mb-0 font-weight-bold">CAIXA INTERNO \ BANCÁRIO</h5>
                  <small class="opacity-75">Seleção de conta e período de trabalho</small>
                </div>
              </div>
              
              <div class="d-flex align-items-center filter-bar bg-white-10 rounded-pill p-1">
                <div class="px-3 d-none d-md-block border-right border-white-20">
                  <small class="text-uppercase font-weight-bold letter-spacing-1">Conta:</small>
                </div>
                <cec-select-search
                  v-model="registro.CONTA_ID" 
                  :options="optionscontas" 
                  :state="registro.CONTA_ID != null"
                  placeholder="-- Escolha uma Conta --"
                  input-class="border-0 bg-transparent custom-select-transparent font-weight-bold mr-2"
                  input-style="color: white !important;"
                  style="min-width: 300px;"
                />

                <div class="px-3 d-none d-md-block border-left border-white-20">
                  <small class="text-uppercase font-weight-bold letter-spacing-1">Data:</small>
                </div>
                <div class="d-flex align-items-center bg-transparent">
                  <cec-input-data
                    v-model="registro.DT_MOV"
                    style="width: 140px;"
                    class="modern-date-input"
                  />
                </div>
                
                <b-button type="submit" variant="success" pill class="ml-2 px-4 font-weight-bold shadow-sm" :disabled="isLoading">
                  <i class="fa fa-sign-in mr-1"></i> Entrar
                </b-button>
              </div>
            </div>

            <div class="dashboard-body bg-white p-5 text-center">
              <div class="mb-4">
                <b-avatar variant="soft-primary" size="5rem" class="shadow-sm">
                  <i class="fa fa-lock fa-2x text-primary"></i>
                </b-avatar>
              </div>
              <h3 class="text-dark font-weight-bold">Acesso ao Movimento</h3>
              <p class="text-muted mx-auto" style="max-width: 500px;">
                Selecione acima a conta bancária ou interna e a data desejada para gerenciar os lançamentos, 
                conciliações e visualizar o resumo financeiro.
              </p>
              <div class="mt-4">
                <div class="d-inline-block p-3 rounded bg-light border">
                  <i class="fa fa-info-circle text-info mr-2"></i>
                  <small class="text-muted">Certifique-se de que o movimento para a data selecionada esteja aberto.</small>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </form>
    
  </div>
</template>

<script>
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import CecInputData from '../../../components/Cec/CecInputData.vue'
import CecSelectSearch from '../../componentes/dropdown/CecSelectSearch.vue'
import moment from 'moment'
import Tools from '@/tools/tools.js'

export default {
  data () {
    return {
      registro: {
        CONTA_ID: null,
        DT_MOV: moment().format('YYYY-MM-DD'),
        DT2: moment().format('YYYY-MM-DD'),
      },
      parametros: {
        nomeConta: '',
      },
      isLoading: false,
      status: '',
      submmited: false,
      optionscontas: []
    }
  },
  components: {
    VueButtonSpinner,
    CecInputData,
    CecSelectSearch
  },
  computed: {
    isValid () {
      if ((this.selected === '1') || (this.selected === '2')) {
        return !!this.registro.CONTA_ID &&  !!this.registro.DT_MOV && !!this.registro.DT2
      } else {
        return !!this.registro.DT_MOV && !!this.registro.DT2
      }
    }
  },
  methods: {
    obterContaIdDaRota () {
      const contaId = Number(this.$route.query?.contaId)
      return Number.isInteger(contaId) && contaId > 0 ? contaId : null
    },
    obterDataDaRota () {
      const dtMov = this.$route.query?.dtMov
      return moment(dtMov, 'YYYY-MM-DD', true).isValid() ? dtMov : moment().format('YYYY-MM-DD')
    },
    aplicarEstadoDaRota () {
      this.registro.DT_MOV = this.obterDataDaRota()

      const contaId = this.obterContaIdDaRota()
      const contaExiste = this.optionscontas.some(conta => Number(conta.value) === contaId)
      this.registro.CONTA_ID = contaExiste ? contaId : null
    },
    CONTA_IDRequerido () {
      return ((this.registro.CONTA_ID && this.submmited) || (this.registro.CONTA_ID && !this.submmited))
    },
    async abrirMovimento () {
      if (!this.registro.CONTA_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Por favor, selecione uma conta.')
        return
      }
      try {
        this.$store.commit('controle/setAguardando', true)
        try {
          await this.$http.post(`/api/protected/conta/verificaacessousuario`, {
            login: window.localStorage.getItem('login'),
            contaId: this.registro.CONTA_ID
          })
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }
        
        let body = {
          contaId: this.registro.CONTA_ID,
          login: window.localStorage.getItem('login'),
          dtMov: this.registro.DT_MOV,
          origem: 'web'
        }
        let movimentoResult = null
        try {
          movimentoResult = await this.$http.post('/api/protected/caixa/abrirmovimento', body)
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }

        const movimentoId = movimentoResult.data?.id?? null

        if (!movimentoId) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel abrir o movimento da conta!' )
          return
        }
        this.$store.commit('controle/setAguardando', false)       
        this.$router.push({
          path: `/movimentos/caixa/lancamento/${movimentoId}`,
          query: {
            contaId: String(this.registro.CONTA_ID),
            dtMov: this.registro.DT_MOV
          }
        })
       
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }  
    }
  },
  created () {
    this.optionscontas = []
    this.registro.CONTA_ID = this.obterContaIdDaRota()
    this.registro.DT_MOV = this.obterDataDaRota()

    const body = {
      login: window.localStorage.getItem('login'),
      origem: 'web'
    }
    
    this.$http.post('api/protected/conta/listarPorLogin', body)
    .then((data) => {
      if (data) {
        let i
        for (i = 0; i < data.data.length; i++) {
          this.optionscontas.push({value: data.data[i].CODIGO, text: data.data[i].NOME_CONTA})
        }
        this.aplicarEstadoDaRota()
      }
      
    }).catch((error) => {
      this.$toast.error({
        title: 'Erro',
        message: 'Não foi possível encontrar as Contas do Sistema ',
        progressBar: false,
        showMethod: 'shake',
        position: 'top full width'
      })
    })
  },
  watch: {
    'registro.CONTA_ID': function () {
      this.CONTA_IDRequerido()
    },
    '$route.query': function () {
      this.aplicarEstadoDaRota()
    }
  }
}
</script>

<style scoped>
/* DashBoard Colors & Vars (Consistent with CaixaLancamento) */
:root {
  --primary-gradient: linear-gradient(135deg, #20a8d8 0%, #1783ae 100%);
}

.dashboard-card {
  border-radius: 12px !important;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.1) !important;
}

.dashboard-header {
  background: linear-gradient(135deg, #343a40 0%, #212529 100%) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.header-icon-wrapper {
  width: 45px;
  height: 45px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
}

.bg-white-10 {
  background: rgba(255, 255, 255, 0.1);
}

.border-white-20 {
  border-color: rgba(255, 255, 255, 0.2) !important;
}

.letter-spacing-1 {
  letter-spacing: 1px;
}

.custom-select-transparent {
  padding-left: 10px;
  cursor: pointer;
  outline: none;
}

.opacity-75 { opacity: 0.75; }

.dashboard-body {
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: radial-gradient(circle at center, #ffffff 0%, #f8f9fa 100%);
}

.b-avatar.variant-soft-primary {
  background-color: #e3f2fd;
}

.modern-date-input {
  box-shadow: none !important;
}
</style>





// WEBPACK FOOTER //
// src/views/movimentos/caixa/CaixaPesquisa.vue